import { CRM_API, RequestHelper } from "utils";

const RUTA = "item";
export const ItemService = (() => {
  const listado = function (args) {
    return new Promise((res) => res(args)).then((params) => {
      return RequestHelper(CRM_API).get("item", params);
    });
  };

  const crear = function (data) {
    return new Promise((res) => res(data)).then((data) => {
      return RequestHelper(CRM_API).postWithFiles("item/CrearItem", data);
    });
  };

  const actualizar = function (itemData) {
    return new Promise((res) => res(itemData)).then((itemData) => {
      return RequestHelper(CRM_API).postWithFiles(`item/${itemData.IdSec}`, itemData);
    });
  };

  const buscarPorId = function (Id) {
    return new Promise((res) => res(Id)).then((IdSec) => {
      return RequestHelper(CRM_API).get(`item/${IdSec}`);
    });
  };

  const exportar = function (args) {
    return new Promise((res) => res(args)).then((params) => {
      return RequestHelper(CRM_API).post(`${RUTA}/exportar`, params, true);
    });
  };

  return { listado, crear, actualizar, buscarPorId, exportar };
})();